import 'whatwg-fetch'
import { __isEnvDev, STORAGE_TYPE_LOCAL } from '../config'
import StorageProviderFactory from '../managers/storage_provider_factory'

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
export const API_JWT_TOKEN_NAME = 'access_token'
export const API_JWT_TOKEN_IAT = 'access_token_iat'
export const API_JWT_REFRESH_TOKEN_NAME = 'refresh_token'
export const APP_USER_NAME = 'username'

export const APP_FF = 'ff'

/**
 * api call using Fetch
 * @param endpoint String
 * @param method String
 * @param tokenType
 * @param body Object
 * @param isEndpointAbs Boolean
 * @returns {Promise.<TResult>}
 */
function callApi(endpoint, method, tokenType, body, isEndpointAbs) {
  const storageProvider = StorageProviderFactory.create(STORAGE_TYPE_LOCAL)
  const token = storageProvider.getItem(tokenType) || null
  let config = {}
  if (token) {
    config = {
      headers: { Authorization: `Bearer ${token}` },
    }
  }

  if (method) {
    config.method = method
    if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
      if (config.hasOwnProperty('headers')) {
        config.headers = Object.assign(config.headers, { 'Content-Type': 'application/json' })
      }
      if (endpoint === '/api/password-reset/' || endpoint === '/api/password-reset/confirm/') {
        // These endpoints are anonymous by contract: no Authorization header, even for a logged-in caller.
        config.headers = { 'Content-Type': 'application/json' }
      }
      if (body) {
        config.body = JSON.stringify(body)
      } else {
        config.body = '{}'
      }
    }
  }
  // add check if endpoint is an absolute URL
  const apiUrl = isEndpointAbs ? endpoint : API_BASE_URL + endpoint
  return window
    .fetch(apiUrl, config)
    .then((response) => {
      if (response.status === 401) {
        window.location.replace('/')
      }
      return response.json().then((data) => ({ data, response }))
    })
    .then(({ data, response }) => {
      if (!response.ok) {
        if (__isEnvDev()) {
          console.log('request failed with status: %s, text: %s', response.status, response.statusText)
        }
        return Promise.reject(data)
      }
      return data
    })
}

export const CALL_API = Symbol('Call API')

// eslint-disable-next-line import/no-anonymous-default-export
export default (store) => (next) => (action) => {
  if (typeof action === 'undefined') {
    return
  }
  const callAPI = action[CALL_API]

  // So the middleware doesn't get applied to every single action
  if (typeof callAPI === 'undefined') {
    return next(action)
  }
  const { endpoint, types, method, body, tokenType, isEndpointAbs } = callAPI
  const [requestType, successType, errorType] = types
  next({ type: requestType })
  return callApi(endpoint, method, tokenType, body, isEndpointAbs).then(
    (response) =>
      next({
        response,
        type: successType,
        requestUrl: endpoint,
      }),
    (error) =>
      next({
        error: error.message || 'There was an error ' + JSON.stringify(error),
        details: error.errors,
        type: errorType,
      })
  )
}
